module.exports = __webpack_public_path__ + "static/media/lg55.33eda169.png";